import { render, staticRenderFns } from "./customModal.vue?vue&type=template&id=cc73b3ee&scoped=true&"
import script from "./customModal.vue?vue&type=script&lang=js&"
export * from "./customModal.vue?vue&type=script&lang=js&"
import style0 from "./customModal.vue?vue&type=style&index=0&id=cc73b3ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc73b3ee",
  null
  
)

export default component.exports